import React from "react";
import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

// --- Types ---
interface SuggestedQuestionsProps {
  onQuestionClick: (question: string) => void;
  disabled?: boolean;
}

// --- Data ---
const INITIAL_QUESTIONS = [
  "Quels sont les avoirs bancaires du défunt ?",
  "Résume les diagnostics immobiliers",
  "Le bien est-il vendu loué ?",
];

// --- Styled Components ---
const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  width: "100%",
  padding: theme.spacing(1.5),
  maxHeight: "200px",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#F3F4F6",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#D1D5DB",
    borderRadius: "3px",
    "&:hover": {
      background: "#9CA3AF",
    },
  },
}));

const QuestionsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  justifyContent: "center",
}));

const QuestionChip = styled(Chip)(({ theme }) => ({
  backgroundColor: "white",
  border: "1px solid #E4E7EC",
  borderRadius: "20px",
  padding: "8px 4px",
  fontSize: "13px",
  fontFamily: "Inter, sans-serif",
  fontWeight: 400,
  color: "#4B5563",
  cursor: "pointer",
  transition: theme.transitions.create(["background-color", "border-color", "box-shadow"], {
    duration: theme.transitions.duration.short,
  }),
  "&:hover": {
    backgroundColor: "#F9FAFB",
    borderColor: theme.palette.primary.main,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
}));

// --- Component ---
export const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({ onQuestionClick, disabled = false }) => {
  const handleQuestionClick = (question: string) => {
    if (!disabled) {
      onQuestionClick(question);
    }
  };

  return (
    <Container>
      {/* Initial Questions */}
      <QuestionsRow>
        {INITIAL_QUESTIONS.map((question, index) => (
          <QuestionChip
            key={`initial-${index}`}
            label={question}
            onClick={() => handleQuestionClick(question)}
            disabled={disabled}
          />
        ))}
      </QuestionsRow>
    </Container>
  );
};

export default SuggestedQuestions;
